<template>
  <div class="width96 margin-auto backwhite pad-bot40">
    <div class="width96 margin-auto all-title f16">专利导航</div>
    <!-- 检索 -->
    <div class="Retrieveform">
      <iframe class="width100 allhight100" :src="report_url"></iframe>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      report_url: "",
    };
  },
  methods: {},
  created() {
    this.report_url = window.sessionStorage.getItem("report_url");
  },
};
</script>
<style scoped>
.all-title {
  height: 56px;
  line-height: 56px;
}
.Retrieveform {
  width: 96%;
  margin: auto;
  min-height: 700px;
  background: #f9f9f9;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>